// Base-14 font naming and its CSS approximation for edit overlays.
import type React from "react";

/** Base-14 name for a family root + bold/italic combination. */
export function base14Name(root: "helv" | "times" | "cour", bold: boolean, italic: boolean): string {
  if (root === "times") {
    return bold && italic
      ? "Times-BoldItalic"
      : bold
        ? "Times-Bold"
        : italic
          ? "Times-Italic"
          : "Times-Roman";
  }
  const base = root === "cour" ? "Courier" : "Helvetica";
  return bold && italic
    ? `${base}-BoldOblique`
    : bold
      ? `${base}-Bold`
      : italic
        ? `${base}-Oblique`
        : base;
}

export function familyOfBase14(base14: string): "helv" | "times" | "cour" {
  return base14.startsWith("Times") ? "times" : base14.startsWith("Courier") ? "cour" : "helv";
}

/** CSS approximation of a Base-14 face for the edit overlay. */
export function base14Css(base14: string): React.CSSProperties {
  return {
    fontFamily: base14.startsWith("Times")
      ? '"Times New Roman", Times, serif'
      : base14.startsWith("Courier")
        ? '"Courier New", Courier, monospace'
        : "Helvetica, Arial, sans-serif",
    fontWeight: /Bold/.test(base14) ? 600 : 400,
    fontStyle: /Italic|Oblique/.test(base14) ? "italic" : "normal",
  };
}
